import { Card, Icon, Image, Text, TextButton } from '@zillow/constellation-10';
import {
  IconChevronLeftFilled,
  IconChevronRightFilled,
  IconFlagOutline,
  IconHeartOutline,
  IconMessageOutline,
  IconMoreFilled,
  IconSendOutline,
  IconZillowMarkLegacy,
} from '@zillow/constellation-icons';
// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
import { styled } from '@/styled-system/jsx';
import { ZillowAvatarImage } from './ZillowAvatarImage';
import { useState } from 'react';

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const InstagramPostContainer = styled(Card, {
  base: {
    maxWidth: '400px',
    padding: '0 !important',
    borderRadius: 0,
    overflow: 'hidden',
    '& img': {
      maxWidth: '400px',
      minWidth: '400px',
      maxHeight: '400px',
      minHeight: '400px',
      objectFit: 'cover',
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const HeaderText = styled(Text, {
  base: {
    lineHeight: 1,
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const MoreLessButton = styled(TextButton, {
  base: {
    color: 'text.dark',
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const IconsContainer = styled('div', {
  base: {
    display: 'flex',
    padding: '12px',
    paddingBottom: 0,
    justifyContent: 'space-between',
    alignItems: 'center',
    '& svg': {
      display: 'inline-block',
      marginRight: '4px',
      cursor: 'pointer',
    },
    '& svg:last-child': {
      marginRight: 0,
    },
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const ImagesContainer = styled('div', {
  base: {
    position: 'relative',
  },
});

// oxlint-disable-next-line constellation/no-styled-factory -- pre-existing styled-components-style usage, not migrating in a lint opt-in
const NextPrevImageButton = styled(TextButton, {
  base: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    color: 'white',
    opacity: 0.8,
  },
  variants: {
    position: {
      left: {
        left: '12px',
      },
      right: {
        right: '12px',
      },
    },
  },
});

export const InstagramPostPreview = ({ imageUrls, description }: { imageUrls: Array<string>; description: string }) => {
  const [activeImageIndex, setActiveImageIndex] = useState(0);
  const [isDescriptionToggled, setIsDescriptionToggled] = useState(false);
  const imageUrl = imageUrls[activeImageIndex];

  const displayDescription = isDescriptionToggled ? description : description.slice(0, 200);

  return (
    <InstagramPostContainer elevated={false}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ marginRight: '8px' }}>
            <ZillowAvatarImage size={36} withInstagramBorder={true}>
              <Icon size="sm" css={{ color: 'white' }}>
                <IconZillowMarkLegacy />
              </Icon>
            </ZillowAvatarImage>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <HeaderText textStyle="body-sm-bold">zillow_rentals</HeaderText>
            <HeaderText textStyle="body-sm">Sponsored</HeaderText>
          </div>
        </div>
        <Icon size="md">
          <IconMoreFilled />
        </Icon>
      </div>
      <ImagesContainer>
        <Image src={imageUrl} />
        {activeImageIndex > 0 && (
          <NextPrevImageButton position="left" onClick={() => setActiveImageIndex(activeImageIndex - 1)}>
            <Icon size="md">
              <IconChevronLeftFilled />
            </Icon>
          </NextPrevImageButton>
        )}
        {activeImageIndex < imageUrls.length - 1 && (
          <NextPrevImageButton position="right" onClick={() => setActiveImageIndex(activeImageIndex + 1)}>
            <Icon size="md">
              <IconChevronRightFilled />
            </Icon>
          </NextPrevImageButton>
        )}
      </ImagesContainer>
      <IconsContainer>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon size="md">
            <IconHeartOutline />
          </Icon>
          <Icon size="md">
            <IconMessageOutline />
          </Icon>
          <Icon size="md">
            <IconSendOutline />
          </Icon>
        </div>
        <Icon size="md">
          <IconFlagOutline />
        </Icon>
      </IconsContainer>
      <div style={{ padding: '12px' }}>
        <Text textStyle="body-bold">zillow_rentals</Text>{' '}
        <Text>
          {displayDescription}
          {!isDescriptionToggled && description.length > 200 && '...'}
        </Text>{' '}
        {description.length > 200 && (
          <MoreLessButton onClick={() => setIsDescriptionToggled(!isDescriptionToggled)}>
            {!isDescriptionToggled ? 'more' : 'less'}
          </MoreLessButton>
        )}
      </div>
    </InstagramPostContainer>
  );
};
